export default "__VITE_ASSET__36fc1f2a__"